import { css } from 'aphrodite';
import { inject } from 'mobx-react';
import * as React from 'react';
import { v4 as uuidgen } from 'uuid';
import { IModalContext, ModalChildComponentContextKey } from '../../../models';
import { baseStyleSheet } from '../../styles/styles';
import { DeprecatedCloseButton } from '../DeprecatedCloseButton';
import { asModalComponent } from '../Modal';
import { RadioButton } from '../RadioButton';
import { styleSheet } from './styles';

export interface IRadioButtonDialogOption<T = any> {
	key?: string | number;
	representedObject?: T;
	title: React.ReactNode;
}

interface IProps<T = any> extends IModalContext<IRadioButtonDialogOption<T>> {
	className?: string;
	footer?: React.ReactNode;
	options?: IRadioButtonDialogOption<T>[];
	title?: React.ReactNode;
}

interface IState<T = any> {
	selectedOption?: IRadioButtonDialogOption<T>;
}

class _RadioButtonOptionsDialog<T = any> extends React.Component<IProps, IState> {
	public readonly state: IState<T> = {};
	private mId = uuidgen();

	public render() {
		const { className, title, options } = this.props;
		const { selectedOption } = this.state;
		return (
			<div className={`${css(styleSheet.container)} radio-button-options-dialog ${className || ''}`}>
				<div className={css(styleSheet.header)}>
					<DeprecatedCloseButton onClick={this.onCloseClicked} />
				</div>
				{!!title && <div className={css(styleSheet.title)}>{title}</div>}
				<div className={css(styleSheet.body)}>
					{!!options &&
						options.map((x, i) => {
							const key = `${x.key || this.mId}-${i}`;
							return (
								<RadioButton
									checked={x === selectedOption || false}
									className={css(styleSheet.radio)}
									id={key}
									key={key}
									name={this.mId}
									onChange={this.onOptionSelected(x)}
								>
									{x.title || ''}
								</RadioButton>
							);
						})}
				</div>
				<div className={css(styleSheet.footer)}>
					<button className={css(baseStyleSheet.ctaButton)} disabled={!selectedOption} onClick={this.onSubmit}>
						<span>Select</span>
					</button>
					<button className={css(styleSheet.cancelButton)} onClick={this.onCloseClicked}>
						<span>Cancel</span>
					</button>
				</div>
			</div>
		);
	}

	private onSubmit = () => {
		const { parentModal } = this.props;
		const { selectedOption } = this.state;
		if (!!parentModal && !!selectedOption) {
			parentModal.onRequestClose(selectedOption, false);
		}
	};

	private onOptionSelected = (selectedOption: IRadioButtonDialogOption<T>) => () => {
		this.setState({
			selectedOption,
		});
	};

	private onCloseClicked = () => {
		const { parentModal } = this.props;
		if (parentModal) {
			parentModal.onRequestClose(null, true);
		}
	};
}

const RadioButtonOptionsDialogWithContext = inject(ModalChildComponentContextKey)(_RadioButtonOptionsDialog);
export const RadioButtonOptionsDialog = asModalComponent(RadioButtonOptionsDialogWithContext, {
	className: 'radio-button-options-dialog-modal',
});
